import React, { useState } from 'react';
import Gateway from './components/Gateway';
import BusinessPortal from './components/BusinessPortal';
import CashLoanPortal from './components/CashLoanPortal';
import WhatsAppButton from './components/WhatsAppButton';
import CashLoanWhatsAppButton from './components/CashLoanWhatsAppButton';

function App() {
  const [currentView, setCurrentView] = useState('gateway');

  const renderView = () => {
    switch (currentView) {
      case 'business':
        return <BusinessPortal onBackToHome={() => setCurrentView('gateway')} />;
      case 'loans':
        return <CashLoanPortal onBackToHome={() => setCurrentView('gateway')} />;
      default:
        return (
          <Gateway
            onSelectBusiness={() => setCurrentView('business')}
            onSelectLoans={() => setCurrentView('loans')}
          />
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {renderView()}
      {currentView === 'loans' ? <CashLoanWhatsAppButton /> : <WhatsAppButton />}
    </div>
  );
}

export default App;